module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-transparent navbar-absolute"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.capitalizeFirstLetter(_vm.$route.name)))])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_vm._m(0), _vm._v(" "), _c('drop-down', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("notifications")]), _vm._v(" "), _c('span', {
    staticClass: "notification"
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Notifications")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mike John responded to your email")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("You have 5 new tasks")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("You're now friend with Andrew")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another Notification")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another One")])])]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dashboard")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Dashboard")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Profile")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "navbar-form navbar-right",
    attrs: {
      "role": "search"
    }
  }, [_c('div', {
    staticClass: "form-group  is-empty"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "material-input"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white btn-round btn-just-icon",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")]), _c('div', {
    staticClass: "ripple-container"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cf6259d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/TopNavbar.vue
// module id = 161
// module chunks = 2